import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  HeadObject: {
    A_VocTyp: "",
    A_VocTypName: "",
    A_VocNo: "0",
    A_PostDt: new Date(),
    A_RefDt: new Date(),
    A_RefNo: "",
    A_Party: "",
    A_PartyName: "",
    A_Curr: "",
    A_Currname: "",
    A_ExRate: "1",
    A_PayMode: "CASH",
    A_Type: "Retail",
    A_Loc: "",
    A_Buyer: "", ////SalesMan
    A_Narr: "", 
    A_DiscPerc: (0).toFixed(2),
    A_Rounding: (0).toFixed(2),
    A_DocStat: "ENTER",
    A_SalesGroup: "", //SalesGroup
    A_TaxType: "OTTRN001",
    A_CUSTFIELD9: "",
    A_Taxable: "Y",  
    A_EnBy:"",
    A_ECOM:"N",
    No:"",
    A_DropShipment:"N",
    Note:"",
    LoyaltyName:"",
    LoyaltyCd:"", 
    Commity: "N", 
    CreditNote: "N",
    A_CrAc: "",
    A_CrAcName: "",
    A_DrAc: "",
    A_DrAcName: "",
    ReqType: "Sales",
  },
  WmsInnContent: {},
  
  WmsInvoiceCheckbox: {
    SalesOrder: false,
    UnitRateLC: false,
    LDisc: false,
    TDisc: false,
    Foc: false,
    Excise: false,
    TaxAmt: true,
    Tax: true,
    Cess: true,
    Narration: true,
    Incentive: true,
    DeliveryOrder:true,
    ItemCode: true,
  },
};

const SliceDelieveryNote = createSlice({
  name: "SliceDelieveryNote",
  initialState: { value: initialState },

  reducers: {
    Set_DelieveryNote_Init: (state) => {
      state.value = initialState;
    },
    Set_HeadObject_Init: (state) => {
      state.value.HeadObject = initialState.HeadObject;
    },
    Set_Modal_Checkbox: (state, action) => {
      state.value.WmsInvoiceCheckbox = action.payload;
    },

    Set_HeadObject_Set: (state, action) => {
      state.value.HeadObject = action.payload;
    },
    Set_HeadObject_DrCrAccount: (state, action) => {
      state.value.HeadObject.A_CrAc = action.payload.A_CrAc;
      state.value.HeadObject.A_CrAcName = action.payload.A_CrAcName;
      state.value.HeadObject.A_DrAc = action.payload.A_DrAc;
      state.value.HeadObject.A_DrAcName = action.payload.A_DrAcName;
    },

    Set_HeadObject_New: (state, action) => {
      state.value.HeadObject.A_VocTyp = action.payload.A_VocTyp;
      state.value.HeadObject.A_VocTypName = action.payload.A_VocTypName;
      state.value.HeadObject.A_VocNo = action.payload.A_VocNo;
      state.value.HeadObject.A_Loc = action.payload.A_Loc;
      state.value.HeadObject.A_Curr = action.payload.A_Curr;
      state.value.HeadObject.A_ExRate = action.payload.A_ExRate;
      state.value.HeadObject.A_Type = action.payload.A_Type;
      state.value.HeadObject.A_Buyer = action.payload.A_Buyer;
      state.value.HeadObject.A_SalesGroup = action.payload.A_SalesGroup;
      state.value.HeadObject.A_TaxType = action.payload.A_TaxType; 
    },

   
 
    Set_HeadObject_A_VocNo_A_DocStat: (state, action) => {
      state.value.HeadObject.A_VocNo = action.payload.A_VocNo;
      state.value.HeadObject.A_DocStat = action.payload.A_DocStat;
    },
    Set_HeadObject_SalesGroup_SalesMan: (state, action) => {
      state.value.HeadObject.A_Buyer = action.payload.A_Buyer;
      state.value.HeadObject.A_SalesGroup = action.payload.A_SalesGroup;
    },
    Set_HeadObject_A_DocStatus: (state, action) => {
      state.value.HeadObject.A_DocStat = action.payload.A_DocStat;
    },
    Set_HeadObject_A_Party: (state, action) => {
      state.value.HeadObject.A_Party = action.payload.A_Party;
      state.value.HeadObject.A_PartyName = action.payload.A_PartyName;
    },

    Set_HeadObject_A_PayMode: (state, action) => {
      state.value.HeadObject.A_PayMode = action.payload.A_PayMode;
    },
  },
});

export const {
  Set_HeadObject_DrCrAccount,
  Set_DelieveryNote_Init,
  Set_HeadObject_Init,
  Set_HeadObject_Set, 
  Set_HeadObject_New,
  Set_HeadObject_A_VocNo_A_DocStat,
  Set_HeadObject_SalesGroup_SalesMan,
  Set_HeadObject_A_DocStatus,
  Set_HeadObject_A_Party,
  Set_HeadObject_A_PayMode, 
  //checkbox
  Set_Modal_Checkbox,
} = SliceDelieveryNote.actions;
export default SliceDelieveryNote.reducer;
